var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hk-button",style:({ width: _vm.customStyle.width })},[_c('p',{staticClass:"hk-button_inner",style:({
            width: _vm.customStyle.width,
            color: _vm.customStyle.color,
            boxShadow: `0px 5px 18px 0px ${_vm.customStyle.shadowColor}`,
            border: _vm.customStyle.border,
            background: _vm.customStyle.background
                ? `linear-gradient(-3deg, ${_vm.customStyle.startColor}, ${_vm.customStyle.endColor})`
                : 'transparent',
            height: _vm.height + 'px',
            borderRadius: `${_vm.height / 2}px`,
            fontSize: _vm.fontSize + 'px'
        }),on:{"click":_vm.handleClick}},[_vm._v(" "+_vm._s(_vm.text)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }